import { FC, PropsWithChildren } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconArrowBack } from '@blocks-react/components/Icons/ArrowBack';
import { CatButtonProps } from '../types';

export const RequestServiceSubHeading: FC<
  PropsWithChildren<CatButtonProps>
> = ({ children, activeStep}) => {
  return (
    <>
      {!!activeStep && (
        <CatButton hideText onClick={activeStep}>
          <CatIconArrowBack slot="before" />
        </CatButton>
      )}
      <CatHeading variant="label">{children}</CatHeading>
    </>
  );
};
